<template>
  <div class="activity-detail">
    <!-- banner -->
    <Sbanner :detailInfo="detailOne" />
    <div class="hd-detail">
      <div class="container" v-if="detailOne">
        <div class="hd-top">
          <div class="item-img" v-if="detailOne.cover_img">
            <img :src="detailOne.cover_img" alt />
          </div>
          <div class="item-txt">
            <h3 class="item-name">{{ detailOne.name }}</h3>
            <div class="item-sub" v-if="activityBrand" @click="goBrandPage(detailOne.brand_id)">{{ activityBrand }}</div>
            <div class="item-detail">
              <p v-if="detailOne.holding_time">
                <span>举办时间：</span>
                <em>{{ detailOne.holding_time | formatStandardDate }}</em>
                <em v-if="detailOne.holdingend_time && detailOne.holding_time != detailOne.holdingend_time"> 至 {{
                  detailOne.holdingend_time | formatStandardDate }}</em>
              </p>
              <p v-if="detailOne.holding_address">
                <span>举办地点：</span>
                <em>{{ detailOne.holding_address }}</em>
              </p>
              <p v-if="detailOne.organizer">
                <span>主办单位：</span>
                <em>{{ detailOne.organizer | formatStandardSep }}</em>
              </p>
              <p v-if="detailOne.organizerby">
                <span>承办单位：</span>
                <em>{{ detailOne.organizerby | formatStandardSep }}</em>
              </p>
            </div>
            <Actions v-if="detailOne.id" banner="2" :view="detailOne.seeCount" :collect="detailOne.collectCount"
              :like="detailOne.likeCount" :row="detailOne" />
          </div>
        </div>

        <div class="skityMenu">
          <h3 class="hd-cate cate2">
            <p :class="{ 'active': relateType == '0' }" v-if="relateProgramlist && relateProgramlist.length > 0"
              @click="goScroll('hdworks', '0')">
              {{ show_menus == 1 ? '活动节目' : show_menus == 2 ? '活动展品' : show_menus == 3 ? '活动文学' : '' }}
            </p>

            <p :class="{ 'active': relateType == '2' }" @click="goScroll('hdjs', '2')">活动介绍</p>
            <p :class="{ 'active': relateType == '4' }" @click="goScroll('jmd', '4')" v-if="showProgramList">节目单</p>
            <p :class="{ 'active': relateType == '3' }" @click="goScroll('hdhb', '3')" v-if="hbList && hbList.length > 0">
              活动海报</p>
            <p :class="{ 'active': relateType == '1' }" v-if="newsList && newsList.length > 0"
              @click="goScroll('hdnews', '1')">相关资讯
            </p>
            <p v-if="detailOne.vr">
              <a :href="detailOne.vr" target="_blank">VR</a>
            </p>

          </h3>
        </div>

        <!-- 活动节目 -->
        <div data-id="0" class="skityItems programlist-show" v-if="relateProgramlist && relateProgramlist.length > 0"
          id="hdworks">
          <template v-if="(show_menus == 1 || show_menus == 2) && relateProgramlist && relateProgramlist.length > 0">
            <template v-for="item in relateProgramlist">
              <ProgramItem :item="item" :showpath="showpath" access="0" newWindow v-if="show_menus == 1" />
              <ExhibitItem :item="item" :showpath="showpath" access="0" v-else-if="show_menus == 2" />
            </template>
          </template>
          <template v-else-if="show_menus == 3">
            <CardTable :list="relateProgramlist" newWindow source="active" v-if="relateProgramlist && relateProgramlist.length > 0" showMulType />
          </template>

          <loading v-if="showLoading" />
          <pagination :total="reProgramTotal" :curPage="reProgramPageIndex" :pageSize="reProgramPageSize"
            @clickPage="programClickPage" v-if="reProgramTotal > 0" />
        </div>

        <!-- 活动介绍 -->
        <div data-id="2" class="skityItems hd-intro" v-if="detailOne.content" id="hdjs">
          <div class="new-title">
            <p class="name">活动介绍</p>
          </div>
          <div class="fold-con" :class="{ 'unfold': introAll }">
            <div class="content" ref="hdIntro" v-html="detailOne.content"></div>
            <div class="fold-mask" @click="$nextTick(() => { introAll = true })" v-if="!introAll">
              <p class="fold-btn flex">
                <span class="iconfont icon-arrow-down"></span>
                <em>加载更多</em>
              </p>
            </div>
          </div>
        </div>

        <!-- 节目单 -->
        <div data-id="4" class="skityItems activity-section playbill" id="jmd" v-if="showProgramList">
          <div class="new-title">
            <p class="name">节目单</p>
          </div>
          <div class="content">
            <div class="playbill-con">
              <div class="con1" v-show="playbillShow == 0" v-html="playBill_con" v-if="playBill_con"></div>
            </div>
          </div>
        </div>

        <!-- 活动海报 -->
        <div data-id="3" class="skityItems activity-section" id="hdhb" v-if="hbList && hbList.length > 0">
          <div class="new-title">
            <p class="name">活动海报</p>
          </div>
          <div class="content full-hb">
            <PosterItem @toDetails="toPosterDetails" :list="hbList" />
          </div>
        </div>

        <!-- 相关资讯 -->
        <div data-id="1" class="skityItems news-list" v-if="newsList && newsList.length > 0" id="hdnews">
          <div class="new-title">
            <p class="name">相关资讯</p>
          </div>
          <template v-for="item in newsList">
            <news-item :item="item" newWindow :showpath="showpath" />
          </template>
          <loading v-if="showLoading" />
          <pagination :total="reNewsTotal" :curPage="reNewsPageIndex" :pageSize="reNewsPageSize"
            @clickPage="NewsClickPage" v-if="reNewsTotal > 0" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Sbanner from "@/components/sbanner";
import ProgramItem from "@/components/listModel/programItem.vue";
import ExhibitItem from "./components/ExhibitItem.vue";
import PosterItem from "./components/PosterItem.vue";
import Pagination from "@/components/pagination.vue";
import Loading from "@/components/common/loading.vue";
import newsItem from "@/components/listModel/newsItem.vue";
import CardTable from "../literature/components/CardTable.vue";
import Viewer from "viewerjs";
import Actions from "../exhibit/components/Actions.vue";
import colums from '@/colums/colums'
export default {
  name: "activityDetail",
  props: {
    msg: String
  },
  components: {
    ProgramItem,
    Pagination,
    Loading,
    newsItem,
    CardTable,
    PosterItem,
    ExhibitItem,
    Sbanner,
    Actions
  },
  data() {
    return {
      showLoading: false,
      curid: 0,
      showpath: "",
      detailOne: {},
      reProgramPageIndex: 1,
      reProgramPageSize: 8,
      reProgramTotal: 0,
      relateProgramlist: [],
      relateType: 2,
      activityBrand: "",

      newsList: [],
      reNewsTotal: 0,
      reNewsPageIndex: 1,
      reNewsPageSize: 4,

      introAll: false,

      playBill_con: "", //节目单内容
      playBill_txt: null, //节目单文本
      playbillShow: 0,
      pragramTotal: 0,
      pragramPageIndex: 1,
      pragramPageSize: 10,

      hbList: [],
      showProgramList: false,
      show_menus: 0,
      cate: colums.literatureCate,
    };
  },
  mounted() {
    let curid = this.$route.params.id;
    this.curid = curid;
    this._getOne(curid);
    window.addEventListener("scroll", this.onScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll, true);
  },
  methods: {
    _getOne(id) {
      let params = {
        id: id
      };
      this.$api.hdkApi.getOneById(params).then(res => {
        this.showpath = res.showpath;
        this.detailOne = res.data;
        this.detailOne.cover_img = this.setImage(res.showpath, this.detailOne.cover_img, `?x-oss-process=image/resize,m_fill,w_680,h_406`)
        this.activityBrand = res.band_name;
        //判断节目介绍是否需要折叠
        if (res.data.content) {
          this.detailOne.content = this.setContent(this.detailOne.content)
          this.$nextTick(() => {
            let height = this.$refs.hdIntro.clientHeight;
            if (height > 800) {
              this.introAll = false;
            } else {
              this.introAll = true;
            }
          });
        }
        this.show_menus = res.show_menus
        if (res.show_menus == 1 || res.show_menus == 2 || res.show_menus == 3) {
          this.getAboutDataList(1)
        }

        if (res.browsing) {
          this.detailOne = {
            ...this.detailOne,
            ...res.browsing
          }
        }

        let program_list = res.data.program_list
        if (program_list && program_list.indexOf('<img') == -1 && program_list.indexOf('<video') == -1) {
          var regex = /<[^>]+>/g;
          program_list = res.data.program_list.replace(regex, '');
        }
        this.playBill_con = this.setContent(res.data.program_list)

        // if (program_list && program_list.indexOf('.pdf') != -1) {
        //   const regex = /<a[^>]+href="([^">]+)"/g;
        //   const matches = program_list.match(regex);
        //   console.log('program_list: ', program_list)
        //   console.log('match: ', matches)
        // }
        // console.log('333')

        this.playbillShow = this.playBill_con ? 0 : 1
        if (program_list) {
          this.showProgramList = true
        }
        this.getNewsList(this.reNewsPageIndex);
        this.gerPosterList();
        // this.getPlayBillList();
        
        this.$nextTick(() => {
          const imgs = this.$el.querySelectorAll('img');
          imgs.forEach(img => {
            img.onerror = () => {
              const srcArr = img.src.split('?')
              img.onerror = null
              img.src = srcArr[0]
            };
          });
        })
      });
    },
    getAboutDataList(pageIndex) {
      if (this.show_menus == 1) {
        this.getRelateProgam(pageIndex);
      } else if (this.show_menus == 2) {
        this.getRelateExhibit(pageIndex);
      } else if (this.show_menus == 3) {
        this.getRelateLiterature(pageIndex);
      }
    },
    // 活动节目
    async getRelateProgam(pageIndex) {
      this.relateProgramlist = null;
      this.showLoading = true;
      let params = {
        page: pageIndex,
        pageSize: this.reProgramPageSize,
        activity_id: this.curid,
        is_top: -1,
        is_award: -1,
        recommend: -1,
      };
      const res = await this.$api.jmkApi.getList(params)
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_fill,w_524,h_336`),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.relateProgramlist = list
      this.reProgramTotal = res.total;
      this.showLoading = false;
      if (this.relateProgramlist && this.relateProgramlist.length) {
        this.relateType = 0
      }
    },
    // 活动展品
    async getRelateExhibit(pageIndex) {
      this.relateProgramlist = null;
      this.showLoading = true;
      let params = {
        page: pageIndex,
        pageSize: this.reProgramPageSize,
        activity_id: this.curid,
        is_top: -1,
        is_award: -1,
        recommend: -1,
      };
      const res = await this.$api.exhibitApi.getList(params)
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_fill,w_524,h_336`),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.relateProgramlist = list
      this.reProgramTotal = res.total;
      this.showLoading = false;
      if (this.relateProgramlist && this.relateProgramlist.length) {
        this.relateType = 0
      }
    },
    // 活动文学
    getRelateLiterature(pageIndex) {
      this.relateProgramlist = null;
      this.showLoading = true;
      let params = {
        page: pageIndex,
        pageSize: this.reProgramPageSize,
        activity_id: this.curid,
        is_top: -1,
        is_award: -1,
        recommend: -1,
      };
      this.$api.literatureApi.getList(params).then(res => {
        let list = res.data || []
        this.relateProgramlist = list.map(v => {
          if (v.category) {
            let obj = this.cate.find(vv => { return v.category == vv.id })
            if (obj) {
              v.category_name = obj.name
              v.path = obj.path
            }
          }
          return {
            ...v,
            author: this.$utils.fixedAuthor(v.listasv)
          }
        })
        this.reProgramTotal = res.total;
        this.showLoading = false;
        if (this.relateProgramlist && this.relateProgramlist.length) {
          this.relateType = 0
        }
      });
    },

    // 相关资讯
    async getNewsList(pageIndex) {
      this.newsList = null;
      this.showLoading = true;
      let params = {
        page: pageIndex,
        pageSize: this.reNewsPageSize,
        activity_id: this.curid,
        is_top: -1,
        is_award: -1,
        recommend: -1,
      };
      const res = await this.$api.newsApi.getList(params)
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_fill,w_600,h_360`),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.showpath = res.showpath;
      this.newsList = list
      this.reNewsTotal = res.total;
      this.showLoading = false;
      if ((!this.relateProgramlist || !this.relateProgramlist.length) && this.newsList && this.newsList.length) {
        this.relateType = 1
      }
    },
    //节目海报
    async gerPosterList() {
      const params = {
        activity_id: this.curid
      }
      const res = await this.$api.posterApi.getActivityList(params);
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_lfit,h_650`, false, ',x_20'),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );

      for (let i in list) {
        const item = list[i]
        const img = item.cover_img
        if (img) {
          const imgObj = await this.loadImage(img)
          const w = imgObj.width
          const h = imgObj.height
          item.imgWidth = Math.floor(w / (h / 325))
        }
      }
      this.hbList = list
    },
    loadImage(url) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          resolve(img); // 图片加载完成，将img对象传递给resolve
        };
        img.onerror = function () {
          reject(new Error('Image load failed')); // 图片加载失败，reject带上错误信息
        };
        img.src = url; // 设置图片的src，开始加载图片
      });
    },

    //节目单 --文本阅读
    async getPlayBillList() {
      this.playBill_txt = null
      this.showLoading = true
      const params = {
        page: this.pragramPageIndex,
        pageSize: this.pragramPageSize,
        activity_id: this.curid
      }
      const res = await this.$api.hdkApi.getProgramList(params)
      const list = res.data || []
      this.pragramTotal = res.total;
      this.showLoading = false;
      this.playBill_txt = list
      if (this.playBill_con || (this.playBill_txt && this.playBill_txt.length)) {
        this.showProgramList = true
      } else {
        this.showProgramList = false
      }
    },

    clickPragramPage(info) {
      if (info.topage > 0) {
        this.pragramPageIndex = info.topage;
        this.getPlayBillList();
      }
    },

    // 活动节目页码翻页
    programClickPage(info) {
      if (info.topage > 0) {
        this.reProgramPageIndex = info.topage;
        this.getAboutDataList(this.reProgramPageIndex);
      }
    },

    NewsClickPage(info) {
      if (info.topage > 0) {
        this.reNewsPageIndex = info.topage;
        this.getNewsList(this.reNewsPageIndex);
      }
    },

    //跳转品牌详情页
    goBrandPage(id) {
      this.$router.push({
        path: "/thematic/" + id
      });
    },

    goScroll(name, index) {
      this.relateType = index
      $("html,body")
        .stop()
        .animate(
          {
            scrollTop: $("#" + name).offset().top - 60
          },
          300
        );
      setTimeout(() => {
        this.relateType = index
      }, 400)
    },
    toPosterDetails({id, t_id}) {
      const path = `/poster/${t_id}?i=${id}`
      try {
        let routeLink = this.$router.resolve({
          path
        })
        window.open(routeLink.href, "_blank")
      } catch (error) {
        this.$router.push({
          path
        })
      }
    },

    //节目海报点击展示大图
    showBigPic(e) {
      // console.log("海报",e)
      let index = this.hbList.findIndex(t => {
        return t.id == e;
      });
      if (index < 0) return;
      var target = document.getElementById("hdhb");
      var viewer = new Viewer(target, {
        url: "data-original",
        initialViewIndex: index,
        hidden: function () {
          viewer.destroy();
        }
      });
      viewer.show();
    },
    onScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let index = $('.skityItems:eq(0)').data('id')
      if ($('.skityItems').length > 1) {
        $('.skityItems').each(function () {
          const vTop = $(this).offset().top
          if (scrollTop > vTop - 100) {
            index = $(this).data('id')
          }
        })
      }
      this.relateType = index
    }
  }
};
</script>
<style lang="scss">
// @import '../../node_modules/viewerjs/dist/viewer.min.css';
.skityItems {
  &.news-list {
    padding-left: 0;
    padding-right: 0;
  }
}

.activity-detail {
  min-height: 80vh;

  .skityMenu {
    position: sticky;
    z-index: 11;
    top: 0;

    .hd-cate {
      position: relative;
      margin-bottom: 30px;
      margin-left: -30px;
      margin-right: -30px;
      padding: 10px 30px 0;
      background-color: #FFF;
      border-bottom: 1px solid #f2f2f2;
    }
  }

  .playbill-con .el-table {
    font-size: 14px;
  }

  .playbill-con .el-table tr {
    height: 54px;
  }

  .playbill-con .el-table th.el-table__cell {
    background: #f7f7f7;
    font-weight: normal;
  }

  .playbill-con .el-table__body .el-table__cell.index,
  .playbill-con .el-table__body .el-table__cell.catename {
    color: #675046;
  }

  .playbill-con .el-table__body .el-table__cell.name {
    font-size: 16px;
  }

  .playbill-con .el-table__cell.catename .cell {
    text-align: right;
  }

  .full-hb .card {
    height: 325px;
    flex-wrap: nowrap;

    &::after {
      content: "";
      flex-grow: 99999;
    }

    .items {
      height: 325px;
      border: none;
    }
  }

  #gallery {
    img {
      width: 0;
      height: 0;
    }
  }

  .playbill-con .con1 {
    img {
      max-width: 100%;
      display: block;
      margin: 0 auto;
      margin-bottom: 10px;
    }
  }
}
</style>